// removed by extract-text-webpack-plugin
module.exports = {"doubleBorder":"AdminMemberProfileContainer__doubleBorder___1MzKq"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/admin/memberApprovedProfile/profile/containers/AdminMemberProfileContainer.scss
// module id = 1567
// module chunks = 0